import { useRef, useEffect, useState } from 'react';

function BouncingBall() {
    const canvasRef = useRef(null);
    const [count, setCount] = useState(1);

    // 画面幅によってボール数を決める
    const calculateBallCount = (width) => {
        if (width <= 400) return 1;
        if (width <= 800) return 2;
        if (width <= 1200) return 4;
        return 6;
    };

    useEffect(() => {
        const updateCount = () => {
            setCount(calculateBallCount(window.innerWidth));
        };
        updateCount(); // 初回
        window.addEventListener('resize', updateCount);
        return () => window.removeEventListener('resize', updateCount);
    }, []);

    useEffect(() => {
        const canvas = canvasRef.current;
        const ctx = canvas.getContext('2d');
        let width = canvas.width = canvas.offsetWidth;
        let height = canvas.height = canvas.offsetHeight;

        const radius = 100;
        const random = (min, max) => Math.random() * (max - min) + min;

        class Ball {
            constructor(x, y, dx, dy, color, text = "") {
                this.x = x;
                this.y = y;
                this.dx = dx;
                this.dy = dy;
                this.color = color;
                this.text = text;
            }

            draw(ctx) {
                ctx.beginPath();
                ctx.arc(this.x, this.y, radius, 0, Math.PI * 2);
                ctx.fillStyle = this.color;
                ctx.fill();
                ctx.closePath();
                if (this.text) {
                    ctx.fillStyle = 'black';
                    ctx.font = 'bold 15px Arial';
                    ctx.textAlign = 'center';
                    ctx.textBaseline = 'middle';
                    ctx.fillText(this.text, this.x, this.y);
                }
            }

            updatePosition() {
                this.x += this.dx;
                this.y += this.dy;
                if (this.x + radius > width || this.x - radius < 0) this.dx = -this.dx;
                if (this.y + radius > height || this.y - radius < 0) this.dy = -this.dy;
            }

            checkCollision(other) {
                const dx = this.x - other.x;
                const dy = this.y - other.y;
                return Math.sqrt(dx * dx + dy * dy) < radius * 2;
            }

            resolveCollision(other) {
                const dx = this.x - other.x;
                const dy = this.y - other.y;
                const tempDx = this.dx;
                const tempDy = this.dy;
                this.dx = other.dx;
                this.dy = other.dy;
                other.dx = tempDx;
                other.dy = tempDy;

                const angle = Math.atan2(dy, dx);
                const overlap = radius * 2 - Math.sqrt(dx * dx + dy * dy);
                const moveX = Math.cos(angle) * (overlap / 2);
                const moveY = Math.sin(angle) * (overlap / 2);
                this.x += moveX;
                this.y += moveY;
                other.x -= moveX;
                other.y -= moveY;
            }
        }

        const balls = [];
        for (let i = 0; i < count; i++) {
            let newBall;
            let overlapping = true;
            while (overlapping) {
                overlapping = false;
                const x = random(radius, width - radius);
                const y = random(radius, height - radius);
                const dx = random(-2, 2) || 1;
                const dy = random(-2, 2) || 1;
                const color = `rgba(255, 255, 255, 1)`;
                newBall = new Ball(x, y, dx, dy, color, "");
                for (let j = 0; j < balls.length; j++) {
                    const other = balls[j];
                    const dx2 = x - other.x;
                    const dy2 = y - other.y;
                    const dist = Math.sqrt(dx2 * dx2 + dy2 * dy2);
                    if (dist < radius * 2) {
                        overlapping = true;
                        break;
                    }
                }
            }
            balls.push(newBall);
        }

        function animate() {
            ctx.clearRect(0, 0, width, height);
            for (let i = 0; i < balls.length; i++) {
                for (let j = i + 1; j < balls.length; j++) {
                    if (balls[i].checkCollision(balls[j])) {
                        balls[i].resolveCollision(balls[j]);
                    }
                }
            }
            balls.forEach(ball => {
                ball.updatePosition();
                ball.draw(ctx);
            });
            requestAnimationFrame(animate);
        }

        animate();

        const handleResize = () => {
            width = canvas.width = canvas.offsetWidth;
            height = canvas.height = canvas.offsetHeight;
        };
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, [count]);

    return (
        <canvas
            ref={canvasRef}
            style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                zIndex: 0,
                pointerEvents: 'none',
            }}
        />
    );
}

export default BouncingBall;
